import React, { useEffect, useState } from "react";
import HeaderNormal from "../components/HeaderNormal";
import Services from "../components/Services"
import "../styles/Voyagez.css"
import  Footer from "../components/Footer"


const Voyagez = () => {
  
  return (
    <div className="voyagez">
        <HeaderNormal />
        <div className="services">
          <Services />
        </div>
        <Footer />
        

    </div>
  );
};

export default Voyagez;
